import React from "react";
import theme from "theme";
import { Theme, Image, LinkBox, Box, Section, Text } from "@quarkly/widgets";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import * as Components from "components";

import articles from "../subpages/_articles_data";

export default () => {
  console.log(articles);
  const articleIds = Object.keys(articles);
  const rows = [];

  for (let i = 0; i < articleIds.length; i += 2) {
    const firstArticle = articles[articleIds[i]];
    const secondArticle = articles[articleIds[i + 1]];

    rows.push(
      <Section
        key={i}
        padding="40px 0 40px 0"
        md-padding="20px 0 12px 0"
        quarkly-title="Section_LatestArticles_Content"
      >
        <Override
          slot="SectionContent"
          flex-direction="row"
          md-flex-wrap="wrap"
        />
        <Box
          display="flex"
          width="100%"
          justify-content="space-between"
          margin-bottom="20px"
        >
          <Box
            empty-border-color="LightGray"
            padding="0px 20px 0px 0px"
            md-padding="0px 0px 0px 0px"
            md-width="100%"
            empty-min-width="64px"
            empty-border-style="solid"
            width="48%"
            empty-min-height="64px"
            empty-border-width="1px"
            align-items="center"
            display="flex"
            flex-direction="column"
            justify-content="flex-start"
            flex-wrap="no-wrap"
          >
            <LinkBox
              href={`/articles/${articleIds[i]}`}
              className="no-underline"
            >
              <Image
                src={firstArticle.image}
                width="100%"
                max-height="400px"
                object-fit="cover"
                lg-max-height="230px"
                height="100%"
              />
              <Text
                sm-margin="24px 0px 16px 0px"
                margin="32px 0px 16px 0px"
                font="--lead"
                color="--green"
                lg-font='normal 600 20px/1.5 "Varta", sans-serif'
                md-margin="12px 0px 16px 0px"
              >
                {firstArticle.title}
              </Text>
              <Text
                margin="0px 0px 0px 0px"
                font="--base"
                color="--light"
                text-align="left"
                lg-font='normal 400 16px/1.5 "Varta", sans-serif'
                md-margin="0px 0px 32px 0px"
              >
                {firstArticle.shortDescription}
              </Text>
            </LinkBox>
          </Box>
          {secondArticle ? (
            <Box
              empty-border-color="LightGray"
              padding="0px 0px 0px 20px"
              md-padding="0px 0px 0px 0px"
              md-width="100%"
              empty-min-width="64px"
              empty-border-style="solid"
              width="48%"
              empty-min-height="64px"
              empty-border-width="1px"
              align-items="center"
              display="flex"
              flex-direction="column"
              justify-content="flex-start"
              flex-wrap="no-wrap"
            >
              <LinkBox
                href={`/articles/${articleIds[i+1]}`}
                className="no-underline"
              >
                <Image
                  src={secondArticle.image}
                  width="100%"
                  max-height="400px"
                  object-fit="cover"
                  lg-max-height="230px"
                  height="100%"
                />
                <Text
                  sm-margin="24px 0px 16px 0px"
                  margin="32px 0px 16px 0px"
                  font="--lead"
                  color="--green"
                  lg-font='normal 600 20px/1.5 "Varta", sans-serif'
                  md-margin="12px 0px 16px 0px"
                >
                  {secondArticle.title}
                </Text>
                <Text
                  margin="0px 0px 0px 0px"
                  font="--base"
                  color="--light"
                  text-align="left"
                  lg-font='normal 400 16px/1.5 "Varta", sans-serif'
                  md-margin="0px 0px 32px 0px"
                >
                  {secondArticle.shortDescription}
                </Text>
              </LinkBox>
            </Box>
          ) : (
            <Box width="48%" />
          )}
        </Box>
      </Section>
    );
  }

  return (
    <Theme theme={theme}>
      <GlobalQuarklyPageStyles pageUrl={"index"} />
      <Components.CombinedHelmetNHeader />
      <Section
        padding="60px 0 40px 0"
        quarkly-title="Section_LatestArticles_Title"
      >
        <Box
          md-width="100%"
          empty-min-width="64px"
          empty-min-height="64px"
          empty-border-width="1px"
          empty-border-style="solid"
          empty-border-color="LightGray"
          width="100%"
          display="flex"
          align-self="auto"
          flex="1 1 0%"
          align-items="center"
          justify-content="center"
          flex-direction="column"
          flex-wrap="no-wrap"
        >
          <Text
            margin="0px 0px 40px 0px"
            color="--light"
            font="--headline2"
            lg-font="normal 500 32px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
            md-margin="0px 0px 16px 0px"
          >
            Latest Articles
          </Text>
          <Text
            color="--light"
            font="--base"
            lg-font='normal 400 16px/1.5 "Varta", sans-serif'
            margin="0px 0px 0px 0px"
            text-align="left"
          >
            Below are all the articles of club activities and project updates
            (in generally descending chronological order).
          </Text>
        </Box>
      </Section>
      {rows}
      <Components.CustomFooter />
      <RawHtml>
        <style place={"endOfHead"} rawKey={"6166a2b829a0a1001e6ca5fb"}>
          {
            ":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}"
          }
        </style>
      </RawHtml>
    </Theme>
  );
};
